import * as dates from '@simplybenefits/sb-dates';
import React, { PureComponent } from 'react';
import Text from '../../../components/Text.js';
import { colors } from '../../../theme/index.js';
import Button from '../../../components/Button.js';
import { Download as DownloadIcon, Info as InfoIcon } from '@mui/icons-material';
import Tooltip from '../../../components/Tooltip.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
import MessageCard from '../../../components/Cards/MessageCard.js';
class AvailableProducts extends PureComponent {
  render() {
    const styles = {
      container: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '0 auto',
        justifyContent: 'space-between'
      },
      titleBlock: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10
      },
      block: {
        width: "calc(50% - 10px)",
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
        marginTop: 20,
        border: `1px solid ${colors.lightGrey}`,
        backgroundColor: colors.surface
      },
      inline: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
      }
    };
    const availableProductIDs = Object.keys(this.props.availableProducts);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: styles.titleBlock
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      margin: "0 0 -10px 0"
    }, i18n.t(tokens.labels.marketplace.availableProducts))), /*#__PURE__*/React.createElement(MessageCard, {
      title: i18n.t(tokens.labels.marketplace.optionalVsVoluntary),
      subtitle: i18n.t(tokens.labels.marketplace.optionalVsVoluntaryDesc)
    }), /*#__PURE__*/React.createElement("div", {
      style: styles.container
    }, availableProductIDs.length === 0 ? /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.marketplace.noProductsAvailable)) : availableProductIDs.map(productID => {
      const product = this.props.availableProducts[productID];
      let productAlreadyPurchased = false;
      let productPurchasedForPrimaryOnly = false;
      if (this.props.purchasedProducts[productID] && this.props.purchasedProducts[productID].primary.effectiveDate) {
        const purchasedProduct = this.props.purchasedProducts[productID];
        productAlreadyPurchased = true;

        // if it's an optional benefits, they cannot change the coverage once purchased. The below code is only for voluntary benefits.
        if (product.type.toUpperCase() === 'VOLUNTARY') {
          const now = dates.getUTC();
          const primaryRenewalDate = purchasedProduct.primary ? dates.getFutureDate(purchasedProduct.primary.effectiveDate, 1, "years") : null;

          // if the product is purchased but not for any dependents then mark it as just purchased for the primary
          if ((!purchasedProduct.dependent || !purchasedProduct.dependent.active) && (!purchasedProduct.spouse || !purchasedProduct.spouse.active) && (!purchasedProduct.child || !purchasedProduct.child.active)) {
            productPurchasedForPrimaryOnly = true;
          }
          if (primaryRenewalDate && now > primaryRenewalDate) {
            productAlreadyPurchased = false;
            productPurchasedForPrimaryOnly = false;
          }

          // if the product does not include dependent coverage we can mark that it is not purchased for primary only as it always is
          if (product.primaryOnlyProduct === 1) {
            productPurchasedForPrimaryOnly = false;
          }
        }
      }
      const carrier = product.carrier[this.props.member.language];
      const name = `${product.type.toUpperCase() === 'VOLUNTARY' ? i18n.t(tokens.labels.marketplace.voluntary) : i18n.t(tokens.labels.marketplace.optional)} ${product.name.primary[this.props.member.language]}`;
      return /*#__PURE__*/React.createElement("div", {
        style: styles.block,
        key: productID
      }, /*#__PURE__*/React.createElement(Text, {
        large: true,
        bold: true,
        margin: "0 0 5px 0"
      }, name), carrier && carrier !== name && /*#__PURE__*/React.createElement("div", {
        style: styles.inline
      }, /*#__PURE__*/React.createElement(Text, {
        tiny: true,
        margin: "0 5px 0 0"
      }, i18n.t(tokens.labels.marketplace.carrier), ":"), /*#__PURE__*/React.createElement(Text, {
        tiny: true,
        bold: true
      }, carrier)), product.enrolmentType === 'closed' && product.enrolmentWindowStart && product.enrolmentWindowEnd && /*#__PURE__*/React.createElement("div", {
        style: {
          ...styles.inline,
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(Text, {
        tiny: true,
        margin: "0 5px 0 0"
      }, i18n.t(tokens.labels.marketplace.enrolmentWindow), ":"), /*#__PURE__*/React.createElement(Text, {
        tiny: true,
        bold: true
      }, dates.getStartOfDay(product.enrolmentWindowStart, "ll", i18n.locale), " ", i18n.t(tokens.labels.claimSummary.to), " ", dates.getStartOfDay(product.enrolmentWindowEnd, "ll", i18n.locale)), /*#__PURE__*/React.createElement(Tooltip, {
        tip: i18n.t(tokens.labels.marketplace.purchaseWithinTimePeriod),
        arrow: true
      }, /*#__PURE__*/React.createElement(InfoIcon, {
        style: {
          marginLeft: 5,
          fontSize: 14,
          color: 'inherit'
        }
      }), "\xA0")), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1,
          marginBottom: 5,
          marginTop: 5
        }
      }, /*#__PURE__*/React.createElement(Text, {
        light: true,
        small: true
      }, product.description[this.props.member.language])), /*#__PURE__*/React.createElement("div", {
        style: {
          ...styles.inline,
          justifyContent: 'flex-end'
        }
      }, product.enBrochure && this.props.member.language === 'en' && /*#__PURE__*/React.createElement(Button, {
        transparent: true,
        customStyle: {
          marginRight: '10px',
          fontSize: 14
        },
        onClick: () => window.open(product.enBrochure, "_blank")
      }, /*#__PURE__*/React.createElement(DownloadIcon, {
        style: {
          fontSize: 18,
          color: 'inherit'
        }
      }), "\xA0", i18n.t(tokens.labels.marketplace.downloadBrochure)), product.frBrochure && this.props.member.language === 'fr' && /*#__PURE__*/React.createElement(Button, {
        transparent: true,
        customStyle: {
          marginRight: '10px',
          fontSize: 14
        },
        onClick: () => window.open(product.frBrochure, "_blank")
      }, /*#__PURE__*/React.createElement(DownloadIcon, {
        style: {
          fontSize: 18,
          color: 'inherit'
        }
      }), "\xA0", i18n.t(tokens.labels.marketplace.downloadBrochure)), productAlreadyPurchased && !productPurchasedForPrimaryOnly ? /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        customStyle: {
          width: 120
        },
        disabled: true
      }, i18n.t(tokens.buttons.purchased)) : productPurchasedForPrimaryOnly ? /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        customStyle: {
          width: "auto"
        },
        onClick: () => this.props.selectProduct(product.productID),
        disabled: !this.props.hasBanking
      }, i18n.t(tokens.buttons.buyForDependents)) : /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        customStyle: {
          width: 100
        },
        onClick: () => this.props.selectProduct(product.productID),
        disabled: !this.props.hasBanking
      }, i18n.t(tokens.buttons.buy))));
    })));
  }
}
export default AvailableProducts;